module.exports = __webpack_public_path__ + "static/media/17IT113.39e59748.jpg";